import React, { useState, useEffect } from "react"; // 👈 incluye useEffect
import { useNavigate } from "react-router-dom";
import "../styles.css";
import logo from "../assets/LOGORSA.png";
import api from "./api";

import { TextField, IconButton, InputAdornment } from "@mui/material";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";

const Login = ({ setAuth, setRole }) => {
  const [user, setUser] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  // ✅ Nuevo bloque: detecta si la sesión expiró
  useEffect(() => {
    if (localStorage.getItem("sessionExpired")) {
      alert("Tu sesión ha expirado. Por favor, inicia sesión nuevamente.");
      localStorage.removeItem("sessionExpired");
    }
  }, []);

  const handleLogin = async () => {
    try {
      const formBody = new URLSearchParams();
      formBody.append("username", user);
      formBody.append("password", password);

      const response = await api.post("/login", formBody.toString(), {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
      });

      const { access_token, role } = response.data;

      localStorage.setItem("token", access_token);
      localStorage.setItem("userRole", role);
      localStorage.setItem("isAuthenticated", "true"); // 👈 añade esto para consistencia

      setAuth(true);
      setRole(role);

      if (role === "admin" || role === "supervisor" || role === "coordinador") {
        navigate("/home");
      } else {
        navigate("/home_usr");
      }
    } catch (error) {
      if (error.response && error.response.data) {
        alert("Error: " + (error.response.data.detail || "Credenciales inválidas"));
      } else {
        console.error("Error en el login:", error);
        alert("No se pudo conectar con el servidor");
      }
    }
  };

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => event.preventDefault();

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleLogin();
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <img src={logo} alt="Logo" className="login-logo" />
        <h1>Iniciar Sesión</h1>

        <TextField
          label="Usuario"
          variant="outlined"
          fullWidth
          margin="normal"
          value={user}
          onChange={(e) => setUser(e.target.value)}
        />

        <TextField
          label="Contraseña"
          variant="outlined"
          fullWidth
          margin="normal"
          type={showPassword ? "text" : "password"}
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          onKeyPress={handleKeyPress}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                >
                  {showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            ),
          }}
        />

        <button onClick={handleLogin} className="login-button">
          Ingresar
        </button>
      </div>
    </div>
  );
};

export default Login;
